import React, { useState } from "react";
import StyledModal from "../components/StyledComponents/StyledModal";
import StyledText from "../components/StyledComponents/StyledText";
import styled from "styled-components";
import { media, validateForm, passwordUpdationValidationRules } from "../utils/helper";
import StyledInput from "../components/StyledComponents/StyledInput";
import StyledButton from "../components/StyledComponents/StyledButton";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import ResetPasswordIcon from "../assets/svgIcons/ResetPasswordIcon";
import { useResetPasswordByTokenMutation } from "../services/apis";
import { toast } from "react-toastify";

const ResetPassword = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [resetPassword, { isLoading }] = useResetPasswordByTokenMutation();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  
  const validationRules = {
    newPassword: passwordUpdationValidationRules,
    confirmPassword: [
      ...passwordUpdationValidationRules,
      {
        condition: (value) => value !== formData.newPassword,
        message: "Passwords do not match",
      },
    ]
  };
  const handleInputChange = (fieldName, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm(formData, validationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      await resetPassword({
        password: formData.newPassword.trim(),
        token: new URLSearchParams(window.location.search).get("token"),
      });
      setFormData({
        newPassword: "",
        confirmPassword: "",
      });
      toast.success(
        "Password updated successfully. Please login with your new password.",
      );
      onHide();
      navigate("/login");
    } catch (error) {
      toast.error(
         error?.errorMessage ||
          error?.data?.errorMessage ||
          error?.data?.errors?.[0]?.errorMessage ||
          "An unexpected error occurred. Please try again.",
      );
      console.error("Reset Password error:", error);
    }
  };
  return (
    <StyledModal show={show} onHide={onHide}>
      <StyledModalBody className="d-flex align-items-center justify-content-center flex-column gap-2 w-100">
        <ResetPasswordIcon />
        <StyledText $fontSize="1rem" $fontWeight="600" className="mt-3 mt-md-4">
          Reset Your Password Here
        </StyledText>
        <Form
          noValidate
          onSubmit={handleSubmit}
          className="py-2 py-md-4 pb-md-5 w-100"
        >
          <StyledInput
            label="Enter new password"
            type="password"
            placeholder="Please enter your password here"
            value={formData.newPassword}
            onChange={(e) => handleInputChange("newPassword", e.target.value)}
            required
            error={errors.newPassword}
          />
          <StyledInput
            label="Confirm your password"
            type="password"
            placeholder="Please retype your password here"
            value={formData.confirmPassword}
            onChange={(e) =>
              handleInputChange("confirmPassword", e.target.value)
            }
            required
            error={errors.confirmPassword}
          />

          <StyledButton
            loading={isLoading}
            _variant="primaryGradiant"
            type="submit"
            className="w-100 p-3 mt-2 fw-semibold"
          >
            Update Password
          </StyledButton>
        </Form>
      </StyledModalBody>
    </StyledModal>
  );
};

const StyledModalBody = styled.div`
  max-width: 75%;
  ${media.xl`
       max-width : 100%;`}
`;
export default ResetPassword;
